import {
  DocumentInclusion,
  DocumentTemplateSummary,
  EncounterSchema,
} from '../config/types';

export const getTemplateInclusion = (
  template: Pick<DocumentTemplateSummary, 'series_id' | 'code'>,
  schema: EncounterSchema,
): DocumentInclusion | undefined => {
  const match = schema.documents.find((document) => {
    if (template.series_id && document.template_series_id) {
      return document.template_series_id === template.series_id;
    }

    return document.code === template.code;
  });

  return match?.inclusion;
};
